import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './FooterCTA.css';

function FooterCTA() {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const handleNavClick = (anchorId) => {
    const el = document.querySelector(anchorId);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate(`/${anchorId}`);
    }
  };

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          {/* Brand Column */}
          <div className="footer-brand">
            <div className="footer-logo-row">
              <img
                src="/durbhasi-gurukulam-logo.png"
                alt="Durbhasi Gurukulam Logo"
                className="footer-logo-img"
              />
              <span className="footer-brand-name">Durbhasi Gurukulam</span>
            </div>
            <p className="footer-desc">
              A specialized software engineering academy delivering mentor-led cohorts in systems programming, backend architectures, database reliability, and cloud infrastructure.
            </p>
            <div className="footer-location">
              Jaipur, Rajasthan, India
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-col">
            <h4 className="footer-col-title">Explore Cohorts</h4>
            <ul className="footer-links">
              <li><Link to="/courses" className="footer-link">All Engineering Programs</Link></li>
              <li><Link to="/courses" className="footer-link">Rust Systems Programming</Link></li>
              <li><Link to="/courses" className="footer-link">Backend Masterclass</Link></li>
              <li><Link to="/courses" className="footer-link">Cloud &amp; DevOps Cohorts</Link></li>
              <li><Link to="/courses" className="footer-link">Database Administration</Link></li>
            </ul>
          </div>

          {/* The Academy */}
          <div className="footer-col">
            <h4 className="footer-col-title">The Academy</h4>
            <ul className="footer-links">
              <li>
                <a href="#pedagogy" onClick={(e) => { e.preventDefault(); handleNavClick('#pedagogy'); }} className="footer-link">
                  The Gurukulam Method
                </a>
              </li>
              <li>
                <a href="#roadmaps" onClick={(e) => { e.preventDefault(); handleNavClick('#roadmaps'); }} className="footer-link">
                  Engineering Roadmaps
                </a>
              </li>
              {/* <li>
                <a href="#mentors" onClick={(e) => { e.preventDefault(); handleNavClick('#mentors'); }} className="footer-link">
                  Faculty &amp; Mentors
                </a>
              </li> */}
              <li>
                <a href="#comparison" onClick={(e) => { e.preventDefault(); handleNavClick('#comparison'); }} className="footer-link">
                  Program Comparison
                </a>
              </li>
              <li>
                <Link to="/support" className="footer-link">
                  Student Support Desk
                </Link>
              </li>
            </ul>
          </div>

          {/* Admissions & Campus */}
          <div className="footer-col">
            <h4 className="footer-col-title">Admissions &amp; Campus</h4>
            <ul className="footer-links">
              <li>
                <span className="footer-meta-label">Helpline:</span>{' '}
                <a href="tel:+917852034945" className="footer-link">+91 7852034945</a>
              </li>
              <li>
                <span className="footer-meta-label">Email:</span>{' '}
                <a href="mailto:info@durbhasigurukulam.com" className="footer-link">info@durbhasigurukulam.com</a>
              </li>
              <li>
                <span className="footer-meta-label">Campus:</span>{' '}
                <span className="footer-address-text">P.No. 18, Radha Vihar, Manchwa, Jaipur</span>
              </li>
              <li>
                <button
                  type="button"
                  className="btn btn-primary btn-sm footer-apply-btn"
                  onClick={() => navigate('/courses')}
                >
                  Apply for Cohorts
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-copyright">
            &copy; {currentYear} Durbhasi Gurukulam. All rights reserved.
          </div>
          <div className="footer-bottom-links">
            <Link to="/support" className="footer-link">Admissions Desk</Link>
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              className="footer-link"
            >
              Back to Top &uarr;
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default FooterCTA;
